module.exports = __webpack_public_path__ + "fonts/Mount-Bold.436f966.woff2";